import React, { useState, useEffect } from 'react';
import { Box, Typography, Button } from '@mui/material';
import 'react-toastify/dist/ReactToastify.css';
import Page from 'src/components/Page';
import palette from 'src/theme/palette';
import ShoppingCartCheckoutIcon from '@mui/icons-material/ShoppingCartCheckout';

export default function Checkout() {
  const handleCheckoutClick = () => {
    console.log(`Checkout Buttton Clicked`);
  };
  return (
    <Page title={`Checkout | ${process.env.REACT_APP_PROJECTNAME}`}>
      <Box sx={{ p: { xs: 2, md: 3 } }}>
        <Box
          sx={{
            display: 'flex',
            flexDirection: { xs: 'column', md: 'row' },
            justifyContent: 'space-between',
            mb: 3,
            mt: 2,
            pb: 2,
            pl: 1,
            gap: 1
          }}
        >
          <Typography
            sx={{
              fontSize: { xs: 20, md: 25 },
              fontFamily: 'poppinsSemiBold',
              color: palette.primary.titledark
            }}
          >
            Checkout
          </Typography>
          <Button
            onClick={handleCheckoutClick}
            variant="contained"
            sx={{
              background: palette.primary.main,
              color: palette.primary.contrastText,
              height: 40,
              '&:hover': { background: palette.primary.dark },
              '&:disabled': { background: palette.grey[400] }
            }}
            startIcon={<ShoppingCartCheckoutIcon />}
          >
            Checkout
          </Button>
        </Box>
      </Box>
    </Page>
  );
}
